import { render, staticRenderFns } from "./TeachingResearch.vue?vue&type=template&id=5a65ef76&scoped=true&"
import script from "./TeachingResearch.vue?vue&type=script&lang=js&"
export * from "./TeachingResearch.vue?vue&type=script&lang=js&"
import style0 from "./TeachingResearch.vue?vue&type=style&index=0&id=5a65ef76&prod&scoped=true&lang=less&"
import style1 from "./TeachingResearch.vue?vue&type=style&index=1&id=5a65ef76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65ef76",
  null
  
)

export default component.exports